import { render, staticRenderFns } from "./TenderOffersPage.vue?vue&type=template&id=12b74c3a&"
import script from "./TenderOffersPage.vue?vue&type=script&lang=js&"
export * from "./TenderOffersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports